import { MessageService } from 'primeng/primeng';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';
import { ListMetadata } from '../../models/list-metadata.model';
import { Param } from '../../models/loyalty-param.model';
import { HttpClientService } from '../httpClient/httpclient.service';


@Injectable()
export class LoyaltyParamsService {

  private cache = new Map<string, Param>();
  public baseUrl = '/koncentro-loyalty';
  private cachedFields: Observable<any>;
  private cachedFieldsChannels: Observable<any>;

  constructor(
    private http: HttpClientService,
    private srvNotify: MessageService
  ) { }

  get(paramId): Observable<Param> {
    if (this.cache.has(paramId)) {
      return Observable.of(this.cache.get(paramId));
    }

    return this.http.get(this.baseUrl + '/params/' + paramId).map(res => {
      // this.cache.set(res.id);
      return res;
    });
  }

  update(param: Param): Observable<Param> {
    return this.http.put(this.baseUrl + '/params/' + param.id, param).map(res => {
      this.cache.delete(param.id);
      return res;
    });
  }

  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<Param>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);

    return this.http.getPaged(this.baseUrl + '/params?' + params.toString());
  }

  create(param: Param): Observable<Param> {
    return this.http.post(this.baseUrl + '/params/' , param );
  }

  remove(paramId): Observable<Param> {
    return this.http.delete(this.baseUrl + '/params/' + paramId).map(res => {
      this.cache.delete(paramId);
      this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      return res;
    });
  }
  recover(param) {
    return this.http.put(this.baseUrl + "/params/recover/" + param.id, param)
      .map(res => {
        this.cache.delete(param.id);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }
  getDistinctParam(): Observable <{data: Array<Param>, metadata: ListMetadata}> {
    return this.http.getPaged(this.baseUrl + '/params/groups/');
  }

  getFunctionalCode(paramGroup: string): Observable <{data: Array<any>}> {
    return this.http.get(this.baseUrl + '/params/getFunctionalCode/' + paramGroup);
  }
/*
  getParamByKey(paramKey: string): Observable<{data: Param}> {
    return this.http.get(this.baseUrl + '/params/getParam', {'paramKey': paramKey});
  }
*/
  getParamByKey(paramKey: string): Observable<Param> {
    return this.http.get(this.baseUrl + '/params/getParam/'+paramKey);
  }
  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get(`${this.baseUrl}/schema/ParamDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

  getFieldsChannels() {
    if (!this.cachedFieldsChannels) {
      this.cachedFieldsChannels = this.http.get(`/koncentro-promo/schema/OChannelDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFieldsChannels;
  }

  /**
   * Restituisce l'url base per il download di pdf relativi alle carte
   */
  getPdfBaseUrl() {
    return this.http.get(`${this.baseUrl}/params/getParam/CARD.PDF_PATH_BASE`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/params.service.ts